export abstract class DashboardChartBase {
  loading = true;

  showLoading() {
    setTimeout(() => {
      this.loading = true;
    });
  }

  hideLoading() {
    setTimeout(() => {
      this.loading = false;
    });
  }
}
